export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/short_video_ads.c020381.svg";